import { ALL_NAMED_GRAPH_IRI } from 'src/templates/queries/iris';

export interface VoiceboxLinkProps {
  database: string;
  connectionDashboard: string;
  hasVirtualGraphs: boolean;
  model: string;
}

export const getVoiceboxLink = ({
  database,
  connectionDashboard,
  hasVirtualGraphs,
  model,
}: VoiceboxLinkProps) => {
  const queryParams = [
    `db=${encodeURIComponent(database)}`,
    `model=${encodeURIComponent(model)}`,
  ];

  if (hasVirtualGraphs) {
    queryParams.push(`graph=${encodeURIComponent(ALL_NAMED_GRAPH_IRI)}`);
  }

  const queryString = queryParams.join('&');
  const url = `${connectionDashboard}voicebox?${queryString}`;

  return url;
};
